import React from 'react';
import PropTypes from 'prop-types';

import './StatusText.scss';

/**
 * This simple component takes a key such as 'pending_review' and returns a <span>
 * with the correct capitalization, spacing, and coloring.
 */
StatusText.propTypes = {
  // Status key to be displayed/converted. I.e. 'in_progress'
  status: PropTypes.string.isRequired,
};
export default function StatusText(props) {
  let displayedText;
  switch (props.status) {
  case 'not_started':
    displayedText = 'Not Started';
    break;
  case 'in_progress':
    displayedText = 'In Progress';
    break;
  case 'pending_review':
    displayedText = 'Pending Review';
    break;
  case 'pending_approval':
    displayedText = 'Pending Approval';
    break;
  default:
    displayedText = null;
  }
  return <span className={'status-text status-text--'+props.status}>{displayedText}</span>;
}



// WEBPACK FOOTER //
// ./src/components/StatusText/index.js